import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import {
    FaCamera, FaEdit, FaSave, FaTimes,
    FaEnvelope, FaPhone, FaMapMarkerAlt,
    FaVenusMars, FaBirthdayCake,
    FaRulerVertical, FaWeight,
    FaMoneyBillWave, FaBriefcase,
    FaStar, FaClock, FaUser,
    FaTimesCircle
} from "react-icons/fa";
import { Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";
import qrCodeImage from "../OSBI.png";
import { baseUrl } from "../App";

function Profile() {

    const [user, setUser] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [gallery, setGallery] = useState([]);
    const [galleryPreview, setGalleryPreview] = useState(null);
    const [selectedPhotoId, setSelectedPhotoId] = useState(null);
    const [transactionData, setTransactionData] = useState({
        transactionType: "",
        transactionId: "",
        transactionDate: "",
        transactionTime: ""
    });
    const [showCropModal, setShowCropModal] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);


    const userId = sessionStorage.getItem("userId");

    useEffect(() => {
        fetchUser();
        fetchGallery();

    }, []);

    const fetchGallery = async () => {
        try {
            const res = await axios.get(`${baseUrl}/user/${userId}`);
            if (Array.isArray(res.data)) {
                setGallery(res.data);
                console.log("gallery data ",res.data)
            } else {
                setGallery([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleAddPhoto = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("photo", file);

        await axios.post(
            `${baseUrl}/add/${userId}`,
            formData
        );

        fetchGallery();
    };

    const handleUpdatePhoto = async (photoId, file) => {
        const formData = new FormData();
        formData.append("photo", file);

        await axios.post(
            `${baseUrl}/update/pic/${photoId}`,
            formData
        );

        fetchGallery();
    };


    const handleDeletePhoto = async (photoId) => {
        await axios.delete(
            `${baseUrl}/delete/${photoId}`
        );

        fetchGallery();
    };


    const fetchUser = async () => {
        try {
            const res = await axios.get(`${baseUrl}/get/${userId}`);
            setUser(res.data);
            console.log("payment_status:", res.data.payment_status, typeof res.data.payment_status);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImageToCrop(reader.result);
                setShowCropModal(true);
            };
            reader.readAsDataURL(file);
        }
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const createImage = (url) =>
        new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => resolve(image));
            image.addEventListener('error', (error) => reject(error));
            image.src = url;
        });

    const getCroppedImg = async (imageSrc, pixelCrop) => {
        const image = await createImage(imageSrc);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, 'image/jpeg');
        });
    };

    const handleCropSave = async () => {
        try {
            const croppedBlob = await getCroppedImg(imageToCrop, croppedAreaPixels);
            const croppedFile = new File([croppedBlob], 'profile.jpg', { type: 'image/jpeg' });
            setImage(croppedFile);
            setPreview(URL.createObjectURL(croppedFile));
            setShowCropModal(false);
            setImageToCrop(null);
        } catch (e) {
            console.error(e);
        }
    };


  const handleUpdate = async () => {
    // Validations
    if (!user.name || !/^[a-zA-Z\s]+$/.test(user.name)) {
      alert("Name must contain only letters");
      return;
    }
    if (!user.email || !user.email.includes("@")) {
      alert("Email must contain @");
      return;
    }
    if (!user.mobile || user.mobile.length !== 10) {
      alert("Mobile must be 10 digits");
      return;
    }
    if (!user.city) {
      alert("Please select a district");
      return;
    }
    if (!user.address) {
      alert("Address is required");
      return;
    }
    if (!user.gender) {
      alert("Please select gender");
      return;
    }
    if (!user.date_of_birth) {
      alert("Date of birth is required");
      return;
    }
    if ((user.gender === "Male" && user.age < 21) || (user.gender === "Female" && user.age < 18)) {
      alert(`Minimum age: ${user.gender === "Male" ? "21" : "18"} years`);
      return;
    }
    if (!user.about_me) {
      alert("About Me is required");
      return;
    }
    if (!user.height) {
      alert("Height is required");
      return;
    }
    if (!user.weight) {
      alert("Weight is required");
      return;
    }
    if (!user.annual_income) {
      alert("Annual income is required");
      return;
    }
    if (!user.work_location) {
      alert("Work location is required");
      return;
    }
    if (!user.qualification) {
      alert("Qualification is required");
      return;
    }
    if (!user.birth_place) {
      alert("Birth place is required");
      return;
    }
    if (!user.birth_time) {
      alert("Birth time is required");
      return;
    }
    if (!/^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i.test(user.birth_time)) {
      alert("Birth time must be in format: 10:30 AM or 10:30AM");
      return;
    }
    if (!user.raasi) {
      alert("Raasi is required");
      return;
    }
    if (!user.star) {
      alert("Star is required");
      return;
    }

    const formData = new FormData();

    formData.append("name", user.name || "");
    formData.append("email", user.email || "");
    formData.append("mobile", user.mobile || "");
    formData.append("address", user.address || "");
    formData.append("city", user.city || "");
    formData.append("gender", user.gender || "");
    formData.append("age", user.age || "");
    formData.append("dateOfBirth", user.date_of_birth || "");
    formData.append("aboutMe", user.about_me || "");
    formData.append("height", user.height || "");
    formData.append("weight", user.weight || "");
    formData.append("annualIncome", user.annual_income || "");
    formData.append("workLocation", user.work_location || "");
    formData.append("qualification", user.qualification || "");
    formData.append("birthPlace", user.birth_place || "");
    formData.append("birthTime", user.birth_time || "");
    formData.append("raasi", user.raasi || "");
    formData.append("star", user.star || "");
    formData.append("active", user.active);

    if (image) formData.append("profilePhoto", image);

    console.log("User data:", user);
    for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
    }

    try {
        const res = await axios.post(`${baseUrl}/update/${userId}`, formData);
        alert(res.data.message);
        setEditMode(false);
        fetchUser();
    } catch (error) {
        alert(error.response?.data?.error || "Update Failed");
    }
};

   const handleToggleActive = () => {
    setUser(prev => ({
        ...prev,
        active: prev.active == 1 ? 0 : 1
    }));
};

    const handleTransactionChange = (e) => {
        setTransactionData({ ...transactionData, [e.target.name]: e.target.value });
    };

    const handleTransactionSubmit = async () => {
        try {
            await axios.put(`${baseUrl}/users/${userId}/transaction`, transactionData);
            alert("Transaction details submitted successfully. Awaiting verification.");
            fetchUser();
        } catch (error) {
            alert("Failed to submit transaction details");
        }
    };

    // 🎨 Colorful Icons Mapping
    const fieldIcons = {
        email: <FaEnvelope color="#0d6efd" />,
        mobile: <FaPhone color="#198754" />,
        address: <FaMapMarkerAlt color="#dc3545" />,
        city: <FaMapMarkerAlt color="#fd7e14" />,
        gender: <FaVenusMars color="#6f42c1" />,
        age: <FaBirthdayCake color="#20c997" />,
        date_of_birth: <FaBirthdayCake color="#0dcaf0" />,
        about_me: <FaUser color="#6610f2" />,
        height: <FaRulerVertical color="#ff5733" />,
        weight: <FaWeight color="#ff9800" />,
        annual_income: <FaMoneyBillWave color="#28a745" />,
        work_location: <FaBriefcase color="#17a2b8" />,
        qualification: <FaBriefcase color="#9c27b0" />,
        birth_place: <FaMapMarkerAlt color="#e83e8c" />,
        birth_time: <FaClock color="#6c757d" />,
        raasi: <FaStar color="#ffc107" />,
        star: <FaStar color="#ffca2c" />
    };

    return (
        <div className="container mt-1 animate__animated animate__fadeIn">
            {user.payment_status !== "\u0001" && user.payment_status != 1 ? (
                <div className="card shadow-lg border-0 p-4">
                    <h3 className="text-center mb-4">Registration Payment Pending</h3>
                    <h6>ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು ಅನ್ವಯಿಸುತ್ತವೆ.</h6>
                    
                    <div className="text-center mb-4">
                        <p className="mb-3">Please make a payment of <strong>Rs. 1000/-</strong> using the QR code below:</p>
                        <img 
                            src={qrCodeImage} 
                            alt="QR Code" 
                            style={{ maxWidth: "300px", width: "100%" }}
                            className="img-fluid mb-3"
                        />
                    </div>

                    <h5 className="mb-3 text-danger">After Payment, Fill Transaction Details:</h5>
                    
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Transaction Type</label>
                            <select 
                                name="transactionType" 
                                className="form-control"
                                value={transactionData.transactionType}
                                onChange={handleTransactionChange}
                                required
                            >
                                <option value="">Select Type</option>
                                <option value="Phonepe">Phonepe</option>
                                <option value="Google-pay">Google Pay</option>
                                <option value="Net-banking">Net Banking</option>
                                <option value="UPI">UPI</option>
                            </select>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Transaction ID (Enter last 6 digits)</label>
                            <input 
                                type="text" 
                                name="transactionId" 
                                className="form-control"
                                value={transactionData.transactionId}
                                onChange={handleTransactionChange}
                                maxLength="6"
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Transaction Date</label>
                            <input 
                                type="date" 
                                name="transactionDate" 
                                className="form-control"
                                value={transactionData.transactionDate}
                                onChange={handleTransactionChange}
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Transaction Time</label>
                            <input 
                                type="time" 
                                name="transactionTime" 
                                className="form-control"
                                value={transactionData.transactionTime}
                                onChange={handleTransactionChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="text-center mt-3">
                        <button 
                            className="btn btn-primary px-4"
                            onClick={handleTransactionSubmit}
                        >
                            Submit Transaction Details
                        </button>
                        
                        <div className="mt-4 pt-3 border-top">
                            <p className="mb-2"><strong>Contact Support:</strong></p>
                            <p className="mb-1"><FaPhone className="me-2" />+91 99455 34640</p>
                            <p className="mb-0"><FaEnvelope className="me-2" />veerashaivaemplay@gmail.com</p>
                        </div>
                    </div>
                </div>
            ) : (
            <div className="card shadow-lg border-0 p-4">

                {/* 🔵 Profile Picture */}
                <div className="text-center mb-4">
                    <div className="position-relative d-inline-block">

                        <img
                            src={
                                preview
                                    ? preview
                                    : `https://lingayatwelfarekarnataka.com/${user.profile_photo_path}`
                            }
                            alt="Profile"
                            className="rounded-circle shadow"
                            style={{
                                width: "180px",
                                height: "180px",
                                objectFit: "cover",
                                border: "5px solid #0d6efd",
                                cursor: "pointer"
                            }}
                            onClick={() => setShowImageModal(true)}
                        />

                        {editMode && (
                            <>
                                <label
                                    htmlFor="imageUpload"
                                    className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-2 shadow"
                                    style={{ cursor: "pointer" }}
                                >
                                    <FaCamera />
                                </label>

                                <input
                                    type="file"
                                    id="imageUpload"
                                    hidden
                                    onChange={handleImage}
                                />
                            </>
                        )}

                    </div>

                    {editMode ? (
                        <>
                            <input
                                type="text"
                                name="name"
                                value={user.name || ""}
                                onChange={handleChange}
                                className="form-control text-center fw-bold mt-3"
                            />
                            <input
                                type="text"
                                name="city"
                                value={user.city || ""}
                                onChange={handleChange}
                                className="form-control text-center mt-2 mb-2"
                            />
                        </>
                    ) : (
                        <>
                            <h4 className="mt-3 fw-bold">{user.name}</h4>
                            <p className="text-muted">{user.city}</p>
                        </>
                    )}
                    <span className={`badge ${user.active == 1 ? "bg-success" : "bg-danger"}`}>
                        {user.active == 1 ? "Active" : "Inactive"}
                    </span>
                </div>

                {/* 🔹 Profile Fields */}
                <div className="row">
                    {Object.keys(fieldIcons).map((field) => (
                        <div className="col-md-6 mb-3" key={field}>

                            <label className="form-label fw-semibold d-flex align-items-center gap-2">
                                {fieldIcons[field]}
                                <span className="text-capitalize">{field}</span>
                            </label>

                            {editMode ? (
                                <input
                                    type="text"
                                    name={field}
                                    value={user[field] || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            ) : (
                                <div className="form-control bg-light">
                                    {user[field]}
                                </div>
                            )}

                        </div>
                    ))}
                </div>

                {/* 🔘 Buttons */}
                <div className="text-center mt-3">
                    {!editMode ? (
                        <button
                            className="btn btn-primary px-4"
                            onClick={() => setEditMode(true)}
                        >
                            <FaEdit className="me-2" />
                            Edit Profile
                        </button>
                    ) : (
                        <>
                            <button
                                className="btn btn-success m-3 px-4"
                                onClick={handleUpdate}
                            >
                                <FaSave className="me-2" />
                                Save
                            </button>

                            <button
                                className="btn btn-secondary me-3 px-4"
                                onClick={() => setEditMode(false)}
                            >
                                <FaTimes className="me-2" />
                                Cancel
                            </button>

                            <button
                                className={`btn px-4 ${user.active == 1 ? "btn-warning" : "btn-success"}`}
                                onClick={handleToggleActive}
                            >
                                {user.active == 1 ? "Deactivate" : "Activate"}
                            </button>
                        </>
                    )}
                </div>

            </div>

            )}

            {/* Crop Modal */}
            <Modal
                show={showCropModal}
                onHide={() => {
                    setShowCropModal(false);
                    setImageToCrop(null);
                }}
                centered
                size="lg"
            >
                <Modal.Header>
                    <h5>Crop Profile Picture</h5>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ position: 'relative', width: '100%', height: '400px' }}>
                        <Cropper
                            image={imageToCrop}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            cropShape="round"
                            showGrid={false}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                        />
                    </div>
                    <div className="mt-3">
                        <label>Zoom</label>
                        <input
                            type="range"
                            min={1}
                            max={3}
                            step={0.1}
                            value={zoom}
                            onChange={(e) => setZoom(e.target.value)}
                            className="form-range"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowCropModal(false)}>
                        Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleCropSave}>
                        Save Crop
                    </button>
                </Modal.Footer>
            </Modal>

            {(user.payment_status === "\u0001" || user.payment_status == 1) && (
            <>
            {/* 🔍 Large Image Modal */}
            <Modal
                show={showImageModal}
                onHide={() => {
                    setShowImageModal(false);
                    setGalleryPreview(null);
                }}
                centered
                size="lg"
            >
                <Modal.Body className="text-center position-relative">

                    <FaTimesCircle
                        size={28}
                        color="red"
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "15px",
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            setShowImageModal(false);
                            setGalleryPreview(null);
                        }}
                    />

                    <img
                        src={
                            galleryPreview
                                ? `https://lingayatwelfarekarnataka.com/${galleryPreview}`
                                : preview
                                ? preview
                                : `https://lingayatwelfarekarnataka.com/${user.profile_photo_path}`
                        }
                        alt="Large Profile"
                        className="img-fluid rounded animate__animated animate__zoomIn"
                        style={{ maxHeight: "80vh" }}
                    />

                </Modal.Body>
            </Modal>


            {/* ================= GALLERY SECTION ================= */}

            <div className="card shadow-lg border-0 p-4 mt-4">

                <h5 className="fw-bold mb-3">Gallery</h5>

                {/* Upload Button */}
                {gallery.length < 4 && (
                    <div className="mb-3">
                        <label className="btn btn-outline-primary">
                            <FaCamera className="me-2" />
                            Add Photo
                            <input
                                type="file"
                                hidden
                                onChange={handleAddPhoto}
                            />
                        </label>
                    </div>
                )}

                <div className="row">

                    {gallery.length === 0 && (
                        <p className="text-muted">No gallery photos uploaded.</p>
                    )}

                    {gallery.map((photo) => (
                        <div key={photo.id} className="col-6 col-md-3 mb-3">

                            <div className="position-relative">

                                <img
                                    src={`https://lingayatwelfarekarnataka.com/${photo.photo_path}`}
                                    alt="Gallery"
                                    className="img-fluid rounded shadow"
                                    style={{
                                        height: "150px",
                                        width: "100%",
                                        objectFit: "cover",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => {
                                        setGalleryPreview(photo.photo_path);
                                        setShowImageModal(true);
                                    }}
                                    onError={(e) => {
                                        console.error("Image failed to load:", photo.photo_path);
                                        e.target.style.display = 'none';
                                    }}
                                />

                                {/* Delete Button */}
                                {/* <button
                                    className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                    onClick={() => handleDeletePhoto(photo.id)}
                                >
                                    <FaTimes />
                                </button> */}

                                {/* Update Button */}
                                <label
                                    className="btn btn-sm btn-primary position-absolute bottom-0 end-0"
                                >
                                    <FaEdit />
                                    <input
                                        type="file"
                                        hidden
                                        onChange={(e) =>
                                            handleUpdatePhoto(photo.id, e.target.files[0])
                                        }
                                    />
                                </label>

                            </div>

                        </div>
                    ))}

                </div>

            </div>
            </>
            )}

        </div>
    );
}

export default Profile;
